import React, { Component, Fragment } from 'react';
import DecisionRow from './DecisionRow';
import { Row, Col, Card, Table } from 'react-bootstrap';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import SearchFilter from '../Reusable/SearchFilter';
import withTranslations from '../../utils/HighOrderComponent';

class DecisionTable extends Component {
  render() {
    const { t, downloadDecisionAttachment } = this.props || {},
      { HeaderColumns, Labels } = t || {},
      { titleTable } = Labels || {};
    const decisionList = this.props.decisionList?.map((decision, index) => (
      <DecisionRow
        index={index + 1}
        key={decision.id}
        decision={decision}
        deleteError={this.props.deleteError}
        error={this.props.error}
        downloadDecisionAttachment={downloadDecisionAttachment}
      />
    ));

    const table = (
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <Row>
                <Col className="col-md-8">
                  <Card.Title as="h3">{titleTable}</Card.Title>
                </Col>
                <Col className="col-md-4">
                  <SearchFilter noSearchColums={2} />
                </Col>
              </Row>
            </Card.Header>

            <Table responsive hover id="table">
              <thead>
                <tr className="text-center">
                  <th className="align-top" width="3%">
                    #
                  </th>
                  <th className="align-top">
                    {HeaderColumns.requestForSignetApproval}
                  </th>
                  <th className="align-top">{HeaderColumns.decisionStatus}</th>
                  <th className="align-top">{HeaderColumns.decisionType}</th>
                  <th className="text-center align-top">
                    {HeaderColumns.dateCreated}
                  </th>
                  <th className="text-center align-top">
                    {HeaderColumns.download}
                  </th>
                </tr>
              </thead>
              <tbody>{decisionList}</tbody>
            </Table>
          </Card>
        </Col>
      </Row>
    );

    return <Fragment>{table}</Fragment>;
  }
}

export default withTranslations(DecisionTable, 'DecisionTable');
